import { call, takeLatest } from "redux-saga/effects";
import {
  CREATE_SETTING,
  SUPPORT_CREATE,
  VIEW_SETTING,
  ACCOUNT_SETTING,
  SETTING_PRIVACY_POLICY_VIEW,
  SETTING_TERMS_CONDTION_VIEW,
  SETTING_TERMS_CONDTION_EDIT,
  SETTING_PRIVACY_POLICY_EDIT,
} from "../actions/types";
import {
  settingCreate,
  settingView,
  accountView,
  privacyPolicyViewApi,
  accountViewApi,
  termsConditionViewApi,
  PrivacyPolicyEditApi,
  termsConditionEditApi,
} from "../apis/settingApi";
import { SupportApi } from "../apis/settingsApi";

export function* supportCreateWorker(action) {
  try {
    const res = yield call(SupportApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
      console.log(res.data);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* createSettingWorker(action) {
  try {
    const res = yield call(settingCreate, {
      order_validity: action.order_validity,
    });
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* viewSettingWorker(action) {
  try {
    const res = yield call(settingView);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* accountSettingWorker(action) {
  try {
    const res = yield call(accountViewApi);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* privaypolicySettingWorker(action) {
  try {
    const res = yield call(privacyPolicyViewApi);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* termsConditionSettingWorker(action) {
  try {
    const res = yield call(termsConditionViewApi);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* PrivacyPolicyEditWorker(action) {
  try {
    const res = yield call(PrivacyPolicyEditApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* termsConditionSettingEditWorker(action) {
  try {
    const res = yield call(termsConditionEditApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* supportCreateWatcher() {
  yield takeLatest(SUPPORT_CREATE, supportCreateWorker);
}

export function* createSettingWatcher() {
  yield takeLatest(CREATE_SETTING, createSettingWorker);
}

export function* viewSettingWatcher() {
  yield takeLatest(VIEW_SETTING, viewSettingWorker);
}

export function* accountSettingWatcher() {
  yield takeLatest(ACCOUNT_SETTING, accountSettingWorker);
}
export function* privaypolicySettingWatcher() {
  yield takeLatest(SETTING_PRIVACY_POLICY_VIEW, privaypolicySettingWorker);
}

export function* termsConditionSettingWatcher() {
  yield takeLatest(SETTING_TERMS_CONDTION_VIEW, termsConditionSettingWorker);
}

export function* PrivacyPolicyEditWatcher() {
  yield takeLatest(SETTING_PRIVACY_POLICY_EDIT, PrivacyPolicyEditWorker);
}

export function* termsConditionSettingEditWatcher() {
  yield takeLatest(
    SETTING_TERMS_CONDTION_EDIT,
    termsConditionSettingEditWorker
  );
}
